"use client";
import { Helmet } from "react-helmet";
import Footer from "../components/default/Footer";
import ProgressScroll from "../components/default/ProgressScroll";
import Header from "../components/default/projects/project-web-countersec/Header";
//import Challenge from "../components/default/projects/project-web-countersec/Challenge";
import Next from "../components/default/projects/project-web-countersec/Next";
//import Story from "../components/default/projects/project-web-countersec/Story";
import ArchiveHeaderTrans from "../components/default/ArchiveHeaderTrans";
import LoadingScreen from "../common/loader";

export default function ProjectCountersec() {
  return (
    <>
      <Helmet>
        <title>Archives | Website Design & Development</title>
        <link rel="icon" href="/dark/imgs/nav/favicon.ico" />
        <link rel="shortcut icon" href="/dark/imgs/nav/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/dark/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/dark/assets/css/style.css"
        />
      </Helmet>
      <body>
        <LoadingScreen />
        <ProgressScroll />
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <main className="main-bg">
              <ArchiveHeaderTrans />
              <Header />
              {/* <Challenge />
              <Story /> */}
              <Next />
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
